import React, { Component } from 'react';
import Banner from './Banner';
import BannerContext from './helpers/BannerContext';

export default class ConnectedBanner extends Component {
  render() {
    return (
      <BannerContext.Consumer>
        {bannerProps => (bannerProps ? <Banner {...bannerProps} /> : null)}
      </BannerContext.Consumer>
    );
  }
}
